import React, { FC, ReactNode, useEffect, useState } from 'react';
import { FAIcon } from '../fa-icon/';
import { i18n } from '../../i18n/translate';

const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning',
};

type Props = {
  children?: ReactNode;
  closeAction?: () => void;
  show?: boolean;
  type?: string;
  dataAttribute?: string;
};

export const InlineNotification: FC<Props> = props => {
  const { type = NOTIFICATION_TYPES.SUCCESS, show = true, children, closeAction, dataAttribute } = props;

  const [visible, setVisible] = useState(false);
  const [iconType, setIconType] = useState('circle-check');

  useEffect(() => {
    setVisible(show);
  }, [show]);

  useEffect(() => {
    const iconsMap = {
      [NOTIFICATION_TYPES.ERROR]: 'circle-minus',
      [NOTIFICATION_TYPES.INFO]: 'circle-info',
      [NOTIFICATION_TYPES.WARNING]: 'triangle-exclamation',
    };

    if (iconsMap[type]) {
      setIconType(iconsMap[type]);
    }
  }, [type]);

  const onClose = () => {
    setVisible(false);
  };

  const close = closeAction || onClose;

  if (!visible) {
    return <></>;
  }

  return (
    <div className={`inline-notification-banner ${type}`} data-attribute={dataAttribute}>
      <div className="banner-icon">
        {/* TODO: remove this ignore after FAIcon is refactored to typescript */}
        {/* @ts-ignore */}
        <FAIcon icon={iconType} />
      </div>

      <div className="banner-text">{children}</div>

      <button className="banner-close-button" aria-label={i18n.t('Dismiss Notification')} onClick={close}>
        {/* TODO: remove this ignore after FAIcon is refactored to typescript */}
        {/* @ts-ignore */}
        <FAIcon icon="xmark" additionalClasses="banner-close" />
      </button>
    </div>
  );
};
